import { CURRENCY_TO_NAME, SUPPORTED_CURRENCIES } from '@util/Currency';
import { Select } from 'antd';
import { App, Currency } from 'hydra-data-types';
import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Color } from '../../../config/Color';
import { ActionType } from '../../../store/ActionTypes';
import { useAppStore } from '../../../store/Store';
import { Environment } from '../../../util/Environment';
import { Flags } from '../../assets/Images';

type Props = {
  loading: boolean;
};

export const CurrencySelect: FunctionComponent<Props> = (props) => {
  const { currency } = useAppStore((state) => state.pricing);
  const dispatch = useDispatch();

  function handleCurrencySelect(value: string) {
    dispatch({ type: ActionType.SET_CURRENCY, currency: value });
  }

  return (
    <CurrencySelectContainer
      data-test="currencySelect"
      value={currency}
      dropdownMatchSelectWidth={255}
      listHeight={500}
      placement="bottomRight"
      dropdownStyle={{
        borderTopLeftRadius: 10,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: 10,
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))',
        padding: 12,
      }}
      optionLabelProp="label"
      loading={props.loading}
      disabled={props.loading}
      onChange={(value = '') => {
        const valueAsString = value as string;
        return handleCurrencySelect(valueAsString.toString());
      }}
      className={Environment.APP === App.Nerva ? 'dark-theme' : ''}
    >
      {SUPPORTED_CURRENCIES.map((currency) => (
        <Select.Option value={currency} key={currency}>
          <CurrencyItem currency={currency} />
        </Select.Option>
      ))}
    </CurrencySelectContainer>
  );
};

const CurrencySelectContainer = styled(Select)`
  .ant-select-selection__rendered {
    padding-right: ${({ theme }) => theme.spacing._4px};
  }
  .ant-select {
    width: 85px;
  }
  .ant-select-item-option-content {
    justify-content: 'center';
    align-items: 'flex-start';
  }

  &.dark-theme {
    .ant-select-selector {
      background-color: ${Color.surface.muted} !important;
      border-color: ${Color.surface.muted} !important;
      border-radius: 12px !important;
      font-size: ${({ theme }) => theme.fontSize.xxs} !important;
    }

    .ant-select-arrow {
      color: ${Color.content.default} !important;
    }

    .ant-select-selection-item {
      color: ${Color.content.default} !important;
      font-size: ${({ theme }) => theme.fontSize.xxs} !important;
    }
  }
`;

type CurrencyItemProps = { currency: Currency };
const CurrencyItem: FunctionComponent<CurrencyItemProps> = (props) => {
  const { currency } = props;
  return (
    <CurrencyContainer>
      <img
        src={Flags[currency]}
        alt={`${currency} Currency Icon`}
        style={{ height: '1.5em', marginRight: 5 }}
      />
      <CurrencyText data-test={`select-cur-item-${currency}`}>
        {currency} - {CURRENCY_TO_NAME[currency]}
      </CurrencyText>
    </CurrencyContainer>
  );
};

const CurrencyText = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const CurrencyContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 30px;
`;
